import React from 'react'
import { RouteHandler, Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import { config } from 'config'
import './style.css'
import '../../static/fonts/fontawesome/style.css'

class SiteLinks extends React.Component {
    render () {

      return (
        <div className="blog-links">
          <ul>
            {config.siteTwitterUrl && (
              <li>
                <a href={config.siteTwitterUrl}>
                  <i className="fa fa-twitter" />
                </a>
              </li>
            )}
            {config.siteGithubUrl && (
              <li>
                <a href={config.siteGithubUrl}>
                  <i className="fa fa-github-alt" />
                </a>
              </li>
            )}
          </ul>
          <ul>
            {config.siteLinkedinUrl && (
              <li>
                <a href={config.siteLinkedinUrl}>
                  <i className="fa fa-linkedin" />
                </a>
              </li>
            )}
            {config.siteTelegramUrl && (
              <li>
                <a href={config.siteTelegramUrl}>
                  <i className="fa fa-paper-plane" />
                </a>
              </li>
                )}
          </ul>
          <ul>
            {config.siteFacebookUrl && (
              <li>
                <a href={config.siteFacebookUrl}><i className="fa fa-facebook" /></a>
              </li>
            )}
          </ul>
        </div>
      )
  }
}

export default SiteLinks



// WEBPACK FOOTER //
// ../components/SiteLinks/index.jsx